import backend from "~/backend"
import Notes from "./Notes"

const DayNotes = ({ dayId, notes: initialNotes }) => {
  const persistChanges = (payload) => {
    backend.updateDay(dayId, { day_notes: payload })
  }
  return <Notes initialNotes={initialNotes} onPersist={persistChanges} />
}

export default DayNotes
